var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.97 2a2 2 0 0 0-1.5.679L2.27 12.005a1.202 1.202 0 0 0 .985 1.96 1.2 1.2 0 0 0 .817-.375l6.332-7.205a.208.208 0 0 1 .365.137V20.8A1.2 1.2 0 0 0 11.97 22a1.2 1.2 0 0 0 1.2-1.201V6.525a.21.21 0 0 1 .364-.138l6.333 7.205a1.2 1.2 0 0 0 1.725.147 1.2 1.2 0 0 0 .075-1.732L13.47 2.68a2 2 0 0 0-1.5-.68"
  })));
};
export default SvgArrowUp;